<template>
    <div>

        <PageHeader>
            {{ $t('productGroups') }}
            <template #side>
                <div class="d-flex gap-3">
                    <ButtonIcon class="width-min-100" variant="primary" :to="{ name: 'ProductGroupsEdit', params: { id: 'add', parentUrl: $route.fullPath } }">
                        {{ $t('addGroup') }}
                    </ButtonIcon>
                </div>
            </template>
        </PageHeader>

        <DataTable
            :fields="fields"
            :items="items"
            :loading="loading"
            :error="error"
            :total-rows="requestData.max"
            :current-page.sync="tableParams.page"
            :per-page.sync="tableParams.perPage"
            :sort-by.sync="tableParams.sort"
            :sort-direction.sync="tableParams.order"
            no-sort-reset
            no-local-sorting
        >
            <template #cell(action)="{item}">
                <div class="d-flex gap-2 justify-content-end">
                    <ButtonIcon size="sm" icon="edit-2" variant="primary" :disabled="isRemoving(item.id)" :to="{ name: 'ProductGroupsEdit', params: { id: item.id, parentUrl: $route.fullPath} }" />
                    <ButtonIcon size="sm" icon="trash-2" variant="danger" :loading="isRemoving(item.id)" @click="removeItem(item)" />
                </div>
            </template>
        </DataTable>

    </div>
</template>



<script>
    import viewFiltersMixin from '@/mixins/viewFiltersMixin';
    import DataTable from '@/components/common/DataTable.vue';

    const DEFAULT_FILTERS_PARAMS = Object.freeze({});
    const DEFAULT_TABLE_PARAMS = Object.freeze({
        perPage: 25,
        page: 1,
    });
    export default {
        name: 'ProductGroups',
        mixins: [viewFiltersMixin],
        components: {
            DataTable,
        },
        data() {
            return {
                ...this.initParams(DEFAULT_FILTERS_PARAMS, DEFAULT_TABLE_PARAMS),
                request: this.$req('producerProductGroups/spaceGroups'),
                requestGroups: this.$req('producerProductGroups/groups'),
            };
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'name', label: this.$t('name') },
                    { key: 'description', label: this.$t('description') },
                    { key: 'productsNo', label: this.$t('productsNo') },
                    { key: 'categoriesNo', label: this.$t('categoriesNo') },
                    { key: 'action', label: '', tdClass: 'text-right', thClass: 'text-right' },
                ];
            },
            spaceId() {
                return this.$store.state.space.currentSpaceId;
            },
            urlParams() {
                return { spaceId: this.spaceId };
            },
        },
        watch: {
            spaceId: {
                handler: 'fetchData',
            },
        },
        methods: {
            isRemoving(id) {
                return this.requestGroups.getLoading(`delete-${id}`);
            },
            removeItem(item) {
                this.$bvModal
                    .msgBoxConfirm(this.$t('confirmYouWantDelete'), {
                        title: this.$t('confirm'),
                        okTitle: this.$t('yes'),
                        cancelTitle: this.$t('cancel'),
                        okVariant: 'danger',
                    })
                    .then(value => {
                        if (value) {
                            this.requestGroups
                                .id(`delete-${item.id}`)
                                .delete({ urlParams: { id: item.id } })
                                .then(this.fetchData)
                                .catch(error => this.$toastr.error(error.message, this.$t('errorOccurred')));
                        }
                    });
            },
        },
    };
</script>
